/**
 * German number formatting for money, quantities and unit prices, and the one definition of how fine a
 * quantity or unit price may be, shared by the record arithmetic, the AI validator and every screen.
 */
const language = 'de-DE';
/**
 * Decimals a quantity or unit price may carry: a Beleg prints prices like 0,3333 EUR je Stück, and six
 * decimals keep any such price as printed while amounts stay at two.
 */
export const PRICE_QUANTITY_DECIMALS = 6;
/** Rounds a quantity or unit price to the decimals the record stores, half away from zero. */
export function roundPreciseNumber(value) {
    const scale = 10 ** PRICE_QUANTITY_DECIMALS;
    return Math.round(value * scale) / scale;
}
export function formatEur(amount) {
    return new Intl.NumberFormat(language, {
        style: 'currency',
        currency: 'EUR',
    }).format(amount);
}
export function formatEurNumber(amount) {
    return new Intl.NumberFormat(language, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(amount);
}
/**
 * A unit price or quantity as a Beleg prints it: at least two decimals, up to six when the value carries
 * them (0,3333 stays 0,3333; 100 reads 100,00), so a fractional-cent price is never rounded away on screen.
 */
export function formatPreciseNumber(amount) {
    return new Intl.NumberFormat(language, {
        minimumFractionDigits: 2,
        maximumFractionDigits: PRICE_QUANTITY_DECIMALS,
    }).format(amount);
}
/** A unit price with its currency, as precise as `formatPreciseNumber` (0,3333 €). */
export function formatPreciseEur(amount) {
    return new Intl.NumberFormat(language, {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: PRICE_QUANTITY_DECIMALS,
    }).format(amount);
}
export function formatNumber(amount, fractionDigits, notation) {
    return new Intl.NumberFormat(language, {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
        notation,
    }).format(amount);
}
export function formatInteger(amount) {
    return new Intl.NumberFormat(language, {
        maximumFractionDigits: 0,
    }).format(amount);
}
